export default {
  inserted(el, binding, vnode) {
    const isShip = vnode.context.$local.data.get('userInfo').isShipSyS
    if (isShip) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  },
}
